import { genericGet } from "../../services/api.service";
import { EntityConfig } from "../../types/EntityConfig";


export const EntradasMaterialConfigs: EntityConfig = [
    {
        id: 'id',
        label: 'Id',
        type: 'id',
        nonEditable: true
    },
    {
        id: 'fornecedor',
        label: 'Fornecedor',
        type: 'select',
        routable: true,
        // nonEditable: true,
        options: {
            name: 'Fornecedor',
            route: 'fornecedores',
            value: 'id',
            label: 'name',
            getter: () => genericGet('/findByFilter/fornecedores'),
        }
    },
    {
        id: 'notaEncomenda',
        label: 'Nota Encomenda',
        type: 'select',
        filterable: true,
        routable: true,
        nonEditable: true,
        options: {
            name: 'Nota Encomenda',
            route: 'notas-encomenda',
            value: 'id',
            label: 'code',
            triggeredGetter: async (i: number) => (await genericGet(`/notas-encomenda?page=1&take=1000000&fornecedor=${i}`)).data, // function to trigger according to other form parameter
            triggerParam: 'fornecedor', // Form parameter used to build getterfunction
            // getter: ()=>genericGet('/findByFilter/notas-encomenda'), // function to trigger according to other form parameter
            searcheable: true
        }
    },
    {
        id: 'observacoes',
        label: 'Observações',
        type: 'text'
    },
    {
        id: 'certificado',
        label: "Certificado",
        type: "text"
    },
    {
        id: 'conformidade',
        label: 'Conformidade',
        type: 'enum',
        filterable: true,
        options: {
            getter: () => genericGet('/entradas-material/conformidades/options'),

        }
    },
    {
        id: 'dataEsperada',
        label: 'Data esperada',
        type: 'date',
        nonEditable: true
    },
    {
        id: 'dataEntrada',
        label: 'Data de entrada',
        type: 'date',
        conditional: (form: any) => {
            console.log("FORM on conditional", form);
            return form.conformidade === 'Conforme' || form.conformidade === 'Não conforme'
        },
    },
    {
        id: 'responsavel',
        label: 'Responsável',
        type: 'select',
        nonEditable: true,
        options: {
            name: 'Responsável',
            label: 'name'
        }
    },
    {
        id: 'motivoNaoConformidade',
        label: 'Motivo (não conformidade)',
        type: 'text',
        options: {
            isMultiLine: true,
            label: 'naoConformidadeFornecedor.motivoNaoConformidade'
        },
        hidden: true,
        conditional: (form: any) => {
            return form.conformidade === 'Não conforme'
        },
    },
    {
        id: 'observacoesNaoConformidade',
        label: 'Observações (não conformidade)',
        type: 'text',
        hidden: true,
        options: {
            isMultiLine: true,
            label: 'naoConformidadeFornecedor.observacoesNaoConformidade'
        },
        conditional: (form: any) => {
            return form.conformidade === 'Não conforme'
        },
    },
    {
        id: 'designacaoNaoConformidade',
        label: 'Designação (não conformidade)',
        type: 'text',
        hidden: true,
        options: {
            isMultiLine: true,
            label: 'naoConformidadeFornecedor.designacaoNaoConformidade'
        },
        conditional: (form: any) => {
            return form.conformidade === 'Não conforme'
        },
    },
    {
        id: 'accoesImediatasNaoConformidade',
        label: 'Acções imediatas (não conformidade)',
        type: 'text',
        hidden: true,
        options: {
            isMultiLine: true,
            label: 'naoConformidadeFornecedor.accoesImediatasNaoConformidade'
        },
        conditional: (form: any) => {
            return form.conformidade === 'Não conforme'
        },
    },
    {
        id: 'naoConformidadeFornecedor',
        label: 'Não conformidade',
        nonEditable: true,
        type: 'select',
        routable: true,
        options: {
            route: 'nao-conformidades-fornecedores',
            label: 'id',
            value: 'id'
        }
    },
    {
        id: 'anexos',
        label: 'Documentos anexos',
        type: 'anexos',
        options: {
          anexosEndpointBuildFunction: (entrada: {naoConformidadeFornecedor : {id: number}}) => `/nao-conformidades-fornecedores/${entrada?.naoConformidadeFornecedor?.id}/anexos`
        },
        conditional: (form: any) => {
            return form.conformidade === 'Não conforme'
        },
        
      },
]